export const DataMutationAddToWishlistProvider_QueryKey = {
  addToWishlist: (): string => {
    const queryKey = "data-mutation-add-to-wishlist";
    return queryKey;
  },
};
